import type { PossibleLanguageItem } from '@core/languages-types';
import { createEntityCollectionStore } from '@core/ngrx-legacy';

import { EntityStoreKey } from '../../types';

const idSelector = (entity: { code: string }) => entity.code;
const { actions, selectors, reducer, namespace } =
  createEntityCollectionStore<PossibleLanguageItem>()(EntityStoreKey.possibleLanguages, {
    idSelector,
  });

export {
  actions as PossibleLanguagesActions,
  selectors as PossibleLanguagesSelectors,
  reducer as PossibleLanguagesReducer,
  namespace as PossibleLanguagesNamespace,
};
